import { supabase } from "@/lib/supabase";

interface InvokeResult {
  ok: boolean;
  error: string | null;
}

/** Calls the rkc-users edge function and normalizes the returned error message. */
export async function callUsersApi(body: Record<string, unknown>): Promise<InvokeResult> {
  const { data, error } = await supabase.functions.invoke("rkc-users", { body });

  if (error) {
    const context = (error as { context?: { json?: () => Promise<{ error?: string }> } }).context;
    if (context?.json) {
      try {
        const parsed = await context.json();
        if (parsed?.error) return { ok: false, error: parsed.error };
      } catch {
        // fall through to the generic message
      }
    }
    return { ok: false, error: "No se pudo completar la operación." };
  }

  const payload = data as { error?: string } | null;
  if (payload?.error) return { ok: false, error: payload.error };
  return { ok: true, error: null };
}